import { render } from "./TaskManagement.vue?vue&type=template&id=1e3d976c&scoped=true"
import script from "./TaskManagement.vue?vue&type=script&lang=ts"
export * from "./TaskManagement.vue?vue&type=script&lang=ts"

import "./TaskManagement.vue?vue&type=style&index=0&id=1e3d976c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1e3d976c"

export default script